export default __webpack_public_path__ + "static/media/07_gallery.1f31aff2.jpg";